import { createFileRoute } from '@tanstack/react-router'
import { AddClinicPage } from '@/features/clinics'

/** S-03 Add clinic. */
export const Route = createFileRoute('/_authed/clinics/new')({
  component: AddClinicPage,
})
